import { type IntentRule, isIntentGraphOverlay } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { option } from 'fp-ts';
import { constNull, flow } from 'fp-ts/lib/function';

export const selectIntentRule: (s: GraphState) => IntentRule | null = flow(
  prop('overlay'),
  option.fromPredicate(isIntentGraphOverlay),
  option.fold(constNull, prop('intentRule')),
);
